import React, { useState } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import CommonModal from './CommonModal';
import CommonPasswordField from './CommonPasswordField';
import { resetPassword } from '../redux/actions/common';
import { formValidation } from '../Utils';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  title: {
    marginRight: 30,
    marginTop: 12,
    float: 'left',
  },
  assignButtonWidth: {
    width: 250,
  },
}));

const ResetPassword = ({ changePassword, userID, onClose }) => {
  const classes = useStyles();
  const [password, setPassword] = useState('');
  const [validation, formValidate] = useState(null)

  const changePass = async () => {
    const valid = await formValidation({ password }, 'resetPassword')
    if (valid === undefined) {
      formValidate(null)
      const data = {
        password,
        userType: 'manager',
      }
      changePassword(data, userID)
      onClose(false)
    } else {
      formValidate(valid)
    }
  }

  return (
    <div className={classes.root}>
      <CommonModal
        title="Reset Password"
        width="sm"
        open
        onYes={changePass}
        onClose={onClose}
        successButtonText="Reset"
        cancelButtonText="Cancel"
        disableEscapeKeyDown
        disableBackdropClick
      >
        <div className="row">
          <div className="col-12">
            <CommonPasswordField
              validation={validation ? validation.password : null}
              handleChange={setPassword}
            />
          </div>
        </div>
      </CommonModal>
    </div>
  );
};

const mapAction = {
  changePassword: resetPassword,
};

export default connect(null, mapAction)(ResetPassword);
